<template>
  <div class="card-container">
    <common-top-form
      selectShowPower="/shopmanage/select"
      :model="formModel"
      :submitService="submitService"
      :submitData="submitData"
      @success="onSuccess"
      @openAddDialog="openAddDialog"
      addShowPower="/shopmanage/add"
    >
      <el-form-item label="名称" prop="name">
        <el-input
          type="text"
          maxlength="20"
          v-model="formModel.name"
          placeholder="请输入名称"
        ></el-input>
      </el-form-item>
      <el-form-item label="机具类型">
        <el-select clearable v-model="formModel.hardwareType">
          <el-option
            v-for="item in hardwareType"
            :key="item.hardwareTypeName"
            :label="item.hardwareTypeName"
            :value="item.hardwareTypeName"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="支付类型">
        <el-select @change="bian" v-model="formModel.payTypeScope">
          <el-option
            v-for="item in payType"
            :key="item.dictKey"
            :label="item.dictValue"
            :value="item.dictKey"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <!-- 新增状态筛选 -->
      <el-form-item label="状态">
        <el-select clearable v-model="formModel.status">
          <el-option
            v-for="item in status"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <!-- 新增筛选 -->
       <el-form-item label='父级'>
        <el-select clearable v-model="formModel.pid">
          <el-option
            v-for="item in fatherList"
            :key="item.id"
            :label="item.goodName"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>
    </common-top-form>
    <common-table :data="tableData" ref="commonTable" @handleChange="getPage">
      <el-table-column
        prop="level"
        label="菜单等级"
        min-width="120"
        :formatter="formatterTableData"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <span v-if="scope.row.level == 1">一级菜单</span>
          <span v-else-if="scope.row.level == 2">二级菜单</span>
          <span v-else>--</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="pid"
        label="父级"
        min-width="120"
        :formatter="formatterTableDataNew"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="type"
        label="类型"
        min-width="120"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="weight"
        label="权重"
        min-width="120"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="goodName"
        label="名称"
        min-width="300"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="hardwareType"
        label="硬件产品类型"
        min-width="160"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="activityStrategy"
        label="活动策略"
        min-width="180"
        :formatter="formatterTableactivityStrategy"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="levelId"
        label="赠送T级别"
        min-width="160"
        :formatter="formatterTableLevelId"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="giftId"
        label="赠送礼包"
        min-width="160"
        :formatter="formatterTablegiftId"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="protectCycle"
        label="T级别保护期(月)"
        min-width="180"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="giftProtectCycle"
        label="礼包保护期(月)"
        min-width="180"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="giveIntegral"
        label="积分"
        min-width="180"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="limitNumber"
        label="购买数量限制"
        min-width="120"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="price"
        label="价格"
        min-width="120"
        :formatter="formatterTableNumberYuan"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="returnPrice"
        label="返上级"
        min-width="120"
        :formatter="formatterTableNumberYuan"
        show-overflow-tooltip
      ></el-table-column>
      <!-- 新增返上上级和收单业绩 -->
      <el-table-column
        prop="returnPriceTwo"
        label="返上上级"
        min-width="120"
        :formatter="formatterTableNumberYuan"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="sdAchievement"
        label="收单业绩"
        min-width="120"
        :formatter="formatterTableNumberYuan"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="sellNumber"
        label="售出数量"
        min-width="120"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="payTypeScope"
        label="支付类型字典"
        min-width="120"
        :formatter="formatterTablepayType"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="payTypeDesc"
        label="支付方式"
        min-width="320"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="upFlag"
        label="是否参与升级"
        min-width="120"
        :formatter="formatterTableData"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <span v-if="scope.row.upFlag == 1">是</span>
          <span v-else-if="scope.row.upFlag == 0">否</span>
          <span v-else>--</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="otherBuyFlag"
        label="是否帮他人购买"
        min-width="150"
        :formatter="formatterTableData"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <span v-if="scope.row.otherBuyFlag == 1">是</span>
          <span v-else-if="scope.row.otherBuyFlag == 0">否</span>
          <span v-else>--</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="numAdjust"
        label="是否购买数量可调"
        min-width="150"
        :formatter="formatterTableData"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <span v-if="scope.row.numAdjust == 1">是</span>
          <span v-else-if="scope.row.numAdjust == 0">否</span>
          <span v-else>--</span>
        </template>
      </el-table-column>
      <el-table-column prop="imgUrl" label="主图" min-width="">
        <template slot-scope="scope">
          <image-viewer class="iconUrl" :src="scope.row.imgUrl"></image-viewer>
        </template>
      </el-table-column>
      <el-table-column prop="otherImgsUrl" label="其他图片" min-width="400">
        <template slot-scope="scope">
          <div class="alliconUrl" v-if="scope.row.otherImgsUrl">
            <div
              v-for="image in scope.row.otherImgsUrl.split(',')"
              :key="image"
            >
              <img class="iconUrl" :src="image" alt="" />
            </div>
          </div>
          <div v-else>暂无其他图片!</div>
        </template>
      </el-table-column>
      <el-table-column
        prop="status"
        label="状态"
        min-width="100"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <el-switch
            v-model="scope.row.status"
            active-color="#13ce66"
            inactive-color="#ff4949"
            active-value="1"
            inactive-value="0"
            @change="statusturns($event, scope.row)"
          />
        </template>
      </el-table-column>
      <el-table-column
        prop="remark"
        label="备注"
        min-width="200"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="createTime"
        label="创建时间"
        min-width="180"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="updateTime"
        label="修改时间"
        min-width="180"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="modifier"
        label="操作人"
        min-width="120"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        v-if="hasPerm('/shopmanage/update') || hasPerm('/shopmanage/del')"
        label="操作"
        min-width="260"
        fixed="right"
      >
        <template slot-scope="scope">
          <el-button
            type="text"
            v-if="hasPerm('/shopmanage/update')"
            @click="openAddDialog(scope.row)"
            >修改
          </el-button>
          <el-button
            type="text"
            v-if="hasPerm('/shopmanage/del')"
            @click="handleDelete(scope.row)"
            >删除
          </el-button>
        </template>
      </el-table-column>
    </common-table>
    <!-- 这里是添加的东西 -->
    <form-dialog
      ref="formDialog"
      :formDialogTitle="itemId ? '修改' : '添加'"
      :model="dialogModel"
      :submitData="dialogData"
      :rules="dialogRules"
      :dialogService="dialogService"
      @close="dialogClose"
      @success="dialogSuccess"
      class="note"
      labelWidth="120px"
      dialogWidth="520px"
    >
      <!-- 新增一级二级菜单 -->
      <el-form-item label="菜单" prop="level">
        <el-select v-model="dialogModel.level" style="width: 198px">
          <el-option
            v-for="item in chooseType"
            :key="item.value"
            :label="item.name"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <!-- 新增类型 -->
      <el-form-item label="类型" prop="type" v-if="dialogModel.level == '1'">
        <el-select v-model="dialogModel.type" style="width: 198px">
          <el-option
            v-for="item in operationType"
            :key="item.dictKey"
            :label="item.dictKey"
            :value="item.dictValue"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="父级" prop="pid" v-if="dialogModel.level == 2">
        <el-select v-model="dialogModel.pid" style="width: 198px">
          <el-option
            v-for="item in fatherList"
            :key="item.id"
            :label="item.goodName"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="权重" prop="weight">
        <el-input-number
          v-model="dialogModel.weight"
          :min="0"
          :max="999999999"
          :step="0"
          :precision="0"
          :controls="false"
          placeholder="请输入"
        ></el-input-number>
      </el-form-item>
      <el-form-item label="名称" prop="goodName">
        <el-input
          type="text"
          maxlength="20"
          v-model="dialogModel.goodName"
          placeholder="请输入名称"
          style="width: 180px"
        ></el-input>
      </el-form-item>
      <el-form-item
        label="硬件产品类型"
        prop="hardwareType"
        v-if="dialogModel.level == 2"
      >
        <el-select v-model="dialogModel.hardwareType" style="width: 198px">
          <el-option
            v-for="item in hardwareTypeStatus"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item
        label="购买数量限制"
        prop="limitNumber"
        v-if="dialogModel.level == 2"
      >
        <el-input-number
          v-model="dialogModel.limitNumber"
          :min="1"
          :max="999999999"
          :step="0"
          :precision="0"
          :controls="false"
          placeholder="请输入"
        ></el-input-number>
      </el-form-item>
      <el-form-item label="价格" prop="price">
        <el-input-number
          v-model="dialogModel.price"
          :min="0"
          :max="999999999"
          :step="0.1"
          :precision="2"
          :controls="false"
          placeholder="请输入"
        ></el-input-number>
      </el-form-item>
      <el-form-item
        label="返上级"
        prop="returnPrice"
        v-if="dialogModel.level == 2"
      >
        <el-input-number
          v-model="dialogModel.returnPrice"
          :min="0"
          :max="999999999"
          :step="0.1"
          :precision="2"
          :controls="false"
          placeholder="请输入"
        ></el-input-number>
      </el-form-item>
      <!-- 新增返上上级和收单业绩 -->
      <el-form-item
        label="返上上级"
        prop="returnPriceTwo"
        v-if="dialogModel.level == 2"
      >
        <el-input-number
          v-model="dialogModel.returnPriceTwo"
          :min="0"
          :max="999999999"
          :step="0.1"
          :precision="2"
          :controls="false"
          placeholder="请输入"
        ></el-input-number>
      </el-form-item>
      <el-form-item
        label="收单业绩"
        prop="sdAchievement"
        v-if="dialogModel.level == 2"
      >
        <el-input-number
          v-model="dialogModel.sdAchievement"
          :min="0"
          :max="999999999"
          :step="0.1"
          :precision="2"
          :controls="false"
          placeholder="请输入"
        ></el-input-number>
      </el-form-item>
      <el-form-item
        label="售出数量"
        prop="sellNumber"
        v-if="dialogModel.level == 2"
      >
        <el-input-number
          v-model="dialogModel.sellNumber"
          :min="0"
          :max="999999999"
          :step="0"
          :precision="0"
          :controls="false"
          placeholder="请输入"
        ></el-input-number>
      </el-form-item>
      <el-form-item label="支付类型" prop="payTypeScope">
        <el-select
          @change="bian"
          v-model="dialogModel.payTypeScope"
          style="width: 198px"
        >
          <el-option
            v-for="item in payType.slice(1, payType.length)"
            :key="item.dictKey"
            :label="item.dictValue"
            :value="item.dictKey"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item
        label="支付方式"
        prop="payTypeIds"
        v-if="dialogModel.level == 2"
      >
        <el-select
          multiple
          v-model="dialogModel.payTypeIds"
          style="width: 198px"
        >
          <el-option
            v-for="item in payTypeIds"
            :key="item.id"
            :label="item.payTypeName"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item
        label-width="160px"
        label="是否参与升级"
        prop="upFlag"
        v-if="dialogModel.level == 2"
      >
        <el-radio-group v-model="dialogModel.upFlag">
          <el-radio :label="0">否</el-radio>
          <el-radio :label="1">是</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item
        label-width="160px"
        label="是否购买数量可调"
        prop="numAdjust"
        v-if="dialogModel.level == 2"
      >
        <el-radio-group v-model="dialogModel.numAdjust">
          <el-radio :label="0">否</el-radio>
          <el-radio :label="1">是</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item
        label-width="160px"
        label="是否帮他人购买"
        prop="otherBuyFlag"
        v-if="dialogModel.level == 2"
      >
        <el-radio-group v-model="dialogModel.otherBuyFlag">
          <el-radio :label="0">否</el-radio>
          <el-radio :label="1">是</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item
        label="活动策略"
        prop="activityStrategy"
        v-if="dialogModel.level == 2"
      >
        <el-select v-model="dialogModel.activityStrategy" style="width: 198px">
          <el-option
            v-for="item in activityStrategyType"
            :key="item.dictKey"
            :label="item.dictValue"
            :value="item.dictKey"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <select-level
        v-model="dialogModel.levelId"
        :selectValue="dialogModel.levelId"
        :needAll="false"
        selectWidth="198px"
        selectProp="levelId"
        organName="赠送T级别"
        v-if="dialogModel.level == 2"
      ></select-level>
      <el-form-item
        label="T级别保护期"
        prop="protectCycle"
        v-if="dialogModel.level == 2"
      >
        <el-input-number
          v-model="dialogModel.protectCycle"
          :min="0"
          :max="999999999"
          :step="0"
          :precision="0"
          :controls="false"
          placeholder="请输入"
        ></el-input-number>
        <span>月</span>
      </el-form-item>
      <div
        v-if="dialogModel.activityStrategy == 'lb' && dialogModel.level == 2"
      >
        <el-form-item label="赠送礼包" prop="giftId">
          <el-select v-model="dialogModel.giftId" style="width: 198px">
            <el-option
              v-for="item in giftLevel"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="礼包保护期"
          prop="giftProtectCycle"
          v-if="dialogModel.level == 2"
        >
          <el-input-number
            v-model="dialogModel.giftProtectCycle"
            :min="0"
            :max="999999999"
            :step="0"
            :precision="0"
            :controls="false"
            placeholder="请输入"
          ></el-input-number>
          <span>月</span>
        </el-form-item>
      </div>
      <el-form-item
        label="赠送积分"
        prop="giveIntegral"
        v-if="dialogModel.level == 2"
      >
        <el-input-number
          v-model="dialogModel.giveIntegral"
          :min="0"
          :max="999999999"
          :step="1"
          :precision="0"
          :controls="false"
          placeholder="请输入"
        ></el-input-number>
      </el-form-item>
      <el-form-item label="主图" prop="imgUrl">
        <el-upload
          class="avatar-uploader"
          :action="uploadUrl + '8883/picture/upload'"
          :data="commonParams"
          name="picture"
          :show-file-list="false"
          :on-success="handleAvatarSuccess"
          :before-upload="beforeAvatarUpload"
        >
          <img
            v-if="dialogModel.imgUrl"
            :src="dialogModel.imgUrl"
            class="avatar"
          />
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload>
      </el-form-item>
      <el-form-item label="其他图片" prop="otherImgsUrl">
        <el-upload
          :action="uploadUrl + '8883/picture/upload'"
          list-type="picture-card"
          :data="commonParams"
          name="picture"
          :show-file-list="false"
          :on-success="handleAvatarSuccess1"
        >
          <i class="el-icon-folder-add"></i>
        </el-upload>
        <div class="newimg">
          <div v-for="url in dialogModel.otherImgsUrl" :key="url">
            <img @click="handleImgClick(url)" :src="url" class="newavatar" />
          </div>
        </div>
      </el-form-item>
      <el-form-item label="备注" prop="remark">
        <el-input
          v-model="dialogModel.remark"
          maxlength="200"
          show-word-limit
          type="textarea"
          rows="3"
        ></el-input>
      </el-form-item>
    </form-dialog>
  </div>
</template>

<script>
import CommonTopForm from "components/common/CommonTopForm";
import CommonTable from "components/common/CommonTable";
import FormDialog from "../../dialog/FormDialog";
import ImageViewer from "../../dialog/ImageViewer";

import ShopService from "service/ShopService";
import PosService from "service/PosService";
import OrganService from "service/OrganService";

import Server from "common/conf/Server";
import SelectLevel from "components/business/SelectLevel";
import privateKey from "service/constant/privateKey";
import { encrypt, urlEncode, objKeySort } from "common/js/common-utils";
import { loadMixin, dialogMixin, validatorsMixin } from "mixin";
import { mapGetters } from "vuex";

export default {
  name: "shopmanage",
  components: {
    CommonTopForm,
    CommonTable,
    FormDialog,
    SelectLevel,
    ImageViewer,
  },
  data() {
    return {
      uploadUrl: Server[process.env.NODE_ENV],
      show: false,
      formModel: {
        name: "",
      },
      tableData: [],
      submitService: ShopService.shopmanageList,
      page: {},
      isPage: false,
      itemId: "",
      dialogModel: {
        goodName: "",
        hardwareType: "",
        levelId: "",
        payTypeScope: "",
        status: "",
        payTypeIds: [],
        upFlag: 0,
        giveIntegral: 0,
        otherBuyFlag: 0,
        activityStrategy: "",
        numAdjust: 0,
        weight: 0,
        limitNumber: 0,
        sellNumber: 0,
        protectCycle: 0,
        price: 0,
        returnPrice: 0,
        returnPriceTwo: 0,
        sdAchievement: 0,
        giftProtectCycle: 0,
        giftId: "",
        imgUrl: "",
        otherImgsUrl: [],
        remark: "",
        level: "2",
        type: "",
        pid: "",
      },
      hardwareTypeStatus: [],
      fatherList: [],
      chooseType: [
        { name: "一级菜单", value: "1" },
        { name: "二级菜单", value: "2" },
      ],
      activityStrategyType: [],
      giftLevel: [],
      hardwareType: [],
      status: [
        {
          label: "启用",
          value: "1",
        },
        {
          label: "禁用",
          value: "0",
        },
      ],
      dialogRules: {
        level: [
          {
            required: true,
            message: "请选择",
          },
        ],
        type: [
          {
            required: true,
            message: "请选择",
          },
        ],
        pid: [
          {
            required: true,
            message: "请选择",
          },
        ],
        hardwareType: [
          {
            required: true,
            message: "请选择",
          },
        ],
        goodName: [
          {
            required: true,
            message: "请输入",
          },
        ],
        hardwareType: [
          {
            required: true,
            message: "请选择",
          },
        ],
        payTypeScope: [
          {
            required: true,
            message: "请选择",
          },
        ],
        payTypeIds: [
          {
            required: true,
            message: "请选择",
          },
        ],
        upFlag: [
          {
            required: true,
            message: "请选择",
          },
        ],
        otherBuyFlag: [
          {
            required: true,
            message: "请选择",
          },
        ],
        numAdjust: [
          {
            required: true,
            message: "请选择",
          },
        ],
        limitNumber: [
          {
            required: true,
            message: "请输入",
          },
        ],
        price: [
          {
            required: true,
            message: "请输入",
          },
        ],
        imgUrl: [
          {
            required: true,
            message: "请选择你要上传的图片",
          },
        ],
        // otherImgsUrl: [
        //   {
        //     required: true,
        //     message: "请选择你要上传的图片",
        //   },
        // ],
      },
      isFlag: false,
      checkAll: false,
      checkedCities: [],
      Mem: [],
      payType: [],
      payTypeIds: [],
      operationType: [], // 添加时候需要添加的类型
    };
  },
  inject: ["reload"],
  mixins: [loadMixin, dialogMixin, validatorsMixin],
  mounted() {
    this.load();
    this.getTypeNames("payType", (res) => {
      this.payType = [
        {
          dictKey: "",
          dictValue: "全部",
        },
        ...res,
      ];
    });
    this.getTypeNames("商品类型", (res) => {
      this.operationType = [...res];
    });
  },
  computed: {
    submitData() {
      this.params = {
        name: this.formModel.name,
        hardwareType: this.formModel.hardwareType,
        payTypeScope: this.formModel.payTypeScope,
        status: this.formModel.status,
        pid: this.formModel.pid,
        current: this.isPage ? this.page.currentPage : 1,
        size: this.page.pageSize,
      };
      return this.params;
    },
    dialogData() {
      const params = {
        goodName: this.dialogModel.goodName,
        hardwareType: this.dialogModel.hardwareType,
        payTypeScope: this.dialogModel.payTypeScope,
        payTypeIds: this.dialogModel.payTypeIds.join(","),
        upFlag: this.dialogModel.upFlag,
        otherBuyFlag: this.dialogModel.otherBuyFlag,
        activityStrategy: this.dialogModel.activityStrategy,
        numAdjust: this.dialogModel.numAdjust,
        levelId: this.dialogModel.levelId,
        giveIntegral: this.dialogModel.giveIntegral,
        weight: this.dialogModel.weight,
        limitNumber: this.dialogModel.limitNumber,
        sellNumber: this.dialogModel.sellNumber,
        protectCycle: this.dialogModel.protectCycle,

        price: this.dialogModel.price,
        returnPrice: this.dialogModel.returnPrice,
        returnPriceTwo: this.dialogModel.returnPriceTwo,
        sdAchievement: this.dialogModel.sdAchievement,
        imgUrl: this.dialogModel.imgUrl,
        remark: this.dialogModel.remark,
        otherImgsUrl: this.dialogModel.otherImgsUrl
          ? this.dialogModel.otherImgsUrl.join(",")
          : "",
        level: this.dialogModel.level,
        type: this.dialogModel.type,
        pid: this.dialogModel.pid,
      };
      if (this.itemId) {
        params.id = this.itemId;
      }
      if (this.dialogModel.activityStrategy == "lb") {
        params.giftId = this.dialogModel.giftId;
        params.giftProtectCycle = this.dialogModel.giftProtectCycle;
      } else {
        params.giftId = "";
        params.giftProtectCycle = 0;
      }
      return params;
    },
    dialogService() {
      return this.itemId
        ? ShopService.shopmanageEdit
        : ShopService.shopmanageInsert;
    },
    commonParams() {
      const params = {
        serverType: this.serverType,
        tatId: this.tatId,
        reqTime: new Date().format("yyyy-MM-dd HH:mm:ss"),
      };
      params.sign = encrypt(
        urlEncode(objKeySort(params)) + "&priKey=" + privateKey.priKey
      );
      return params;
    },
    ...mapGetters(["serverType", "tatId", "userId"]),
  },
  watch: {},
  methods: {
    formatterTableDataNew(row) {
     
      if (row.level == 2) {
           console.log(row.pid, "rowrowqrow");
        const matchedItem = this.fatherList.find((item) => item.id === row.pid);
        return matchedItem ? matchedItem.goodName : "";
      }
    },
    load() {
      this.formModel = {};
      this.page = this.$refs.commonTable.page;
      this.getList();
      this.getHardwareType();
      this.gethardwareTypeStatus();
      this.getMem();
      this.getgiftLevel();
      this.getFather();
      this.getTypeNames("activity_strategy", (res) => {
        this.activityStrategyType = res;
      });
    },
    getFather() {
      this.doLoad(
        ShopService.getFatherList,
        "",
        (res) => {
          this.doCheck(res, (res) => {
            this.fatherList = [...res.contents];
            console.log(this.fatherList, "WWWWW");
            console.log(res.contents, "resres");
          });
        },
        "信息获取失败"
      );
    },
    getPage() {
      this.isPage = true;
      this.getList();
    },
    getList() {
      this.doLoad(
        this.submitService,
        this.submitData,
        (res) => {
          this.doCheck(res, (res) => {
            this.onSuccess(res);
            this.isPage = false;
          });
        },
        "信息获取失败"
      );
    },
    getHardwareType() {
      this.doLoad(
        PosService.posrateList,
        {
          size: 9999,
        },
        (res) => {
          this.doCheck(res, (res) => {
            this.hardwareType = res.contents.records;
          });
        },
        "信息获取失败"
      );
    },
    getgiftLevel() {
      this.doLoad(
        ShopService.giftpackmanageList,
        {
          size: 9999,
        },
        (res) => {
          this.doCheck(res, (res) => {
            this.giftLevel = res.contents.rows;
          });
        },
        "信息获取失败"
      );
    },
    handleDelete(item) {
      this.showConfirm("是否删除？")
        .then(() => {
          this.doDelete(item.id);
        })
        .catch(() => {});
    },
    doDelete(id) {
      this.doLoad(
        ShopService.shopmanageDel,
        {
          id: id,
        },
        (res) => {
          this.doCheck(res, (res) => {
            this.commonSuccess(res);
          });
        },
        "操作失败"
      );
    },
    statusturns($event, scope) {
      this.doStatus($event, scope);
    },
    doStatus($event, scope) {
      this.doLoad(
        ShopService.shopmanageStatus,
        {
          id: scope.id,
          status: $event,
        },
        (res) => {
          this.doCheck(res, (res) => {
            this.commonSuccess(res);
          });
        },
        "操作失败"
      );
    },
    openAddDialog(item, flag) {
      this.itemId = item ? item.id : "";
      if (this.itemId) {
        this.isFlag = true;
        this.dialogModel = JSON.parse(JSON.stringify(item));

        if (!this.dialogModel.otherImgsUrl) {
          this.dialogModel.otherImgsUrl = [];
        } else {
          this.dialogModel.otherImgsUrl =
            this.dialogModel.otherImgsUrl.split(",");
        }
        this.getIds(this.dialogModel.payTypeScope);
        if (
          this.dialogModel.payTypeIds == null ||
          this.dialogModel.payTypeIds == "" ||
          this.dialogModel.payTypeIds == []
        ) {
          this.dialogModel.payTypeIds = [];
        } else {
          const Arr = this.dialogModel.payTypeIds.split(",");
          this.dialogModel.payTypeIds = Arr.map((item) => Number(item));
        }
      }
      this.gethardwareTypeStatus();
      this.$refs.formDialog.open();
    },

    dialogClose() {
      this.dialogModel = {
        goodName: "",
        hardwareType: "",
        payTypeScope: "",
        payTypeIds: [],
        upFlag: 0,
        otherBuyFlag: 0,
        activityStrategy: "",
        numAdjust: 0,
        giveIntegral: 0,
        levelId: "",
        weight: 0,
        limitNumber: 0,
        sellNumber: 0,
        protectCycle: 0,
        giftId: "",
        giftProtectCycle: 0,
        price: 0,
        returnPrice: 0,
        returnPriceTwo: 0,
        sdAchievement: 0,
        imgUrl: "",
        otherImgsUrl: [],
        remark: "",
        level: "2",
        type: "",
        pid: "",
      };
      this.itemId = "";
      this.payTypeIds = [];
    },
    dialogSuccess(res) {
      this.commonSuccess(res);
      this.$refs.formDialog.closeDialog();
    },
    commonSuccess(res) {
      this.showSuccess(res.respMsg);
      this.getList();
    },
    onSuccess(res) {
      this.doCheck(res, (res) => {
        const result = res.contents;
        this.tableData = result.rows;
        this.page.currentPage = result.current;
        this.page.total = result.total;
        this.page.pageSize = result.size;
      });
    },
    gethardwareTypeStatus() {
      this.doLoad(
        PosService.posYingJianType,
        "",
        (res) => {
          this.doCheck(res, (res) => {
            this.hardwareTypeStatus = res.contents;
          });
        },
        "信息获取失败"
      );
    },
    getMem() {
      //代理商等级
      this.doLoad(
        OrganService.memberupgradeList,
        "",
        (res) => {
          this.doCheck(res, (res) => {
            this.Mem = res.contents.rows;
          });
        },
        "信息获取失败"
      );
    },
    getIds(item) {
      this.doLoad(
        ShopService.shoppaymentList,
        {
          status: 1,
          payType: item,
        },
        (res) => {
          this.doCheck(res, (res) => {
            this.payTypeIds = res.contents;
          });
        },
        "信息获取失败"
      );
    },
    bian(item) {
      this.dialogModel.payTypeIds = [];
      this.getIds(item);
    },
    handleAvatarSuccess(res, file) {
      this.doCheck(res, (res) => {
        this.dialogModel.imgUrl = res.contents;
      });
    },
    beforeAvatarUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 2MB!");
        return isLt2M;
      }
      return isLt2M;
    },
    handleAvatarSuccess1(res, file) {
      this.doCheck(res, (res) => {
        this.dialogModel.otherImgsUrl.push(res.contents);
      });
    },
    handleImgClick(url) {
      this.dialogModel.otherImgsUrl = this.dialogModel.otherImgsUrl.filter(
        (item) => item !== url
      );
    },
    formatterTablepayType(row, column, cellValue, index) {
      let value = "";
      this.payType.forEach((item) => {
        if (item.dictKey == cellValue) {
          value = item.dictValue;
        }
      });

      return value ? value : "--";
    },
    formatterTableLevelId(row, column, cellValue, index) {
      let value = "--";
      this.Mem.forEach((item) => {
        if (item.id == cellValue) {
          value = item.levelName;
        }
      });
      return value;
    },
    formatterTablegiftId(row, column, cellValue, index) {
      let value = "--";
      this.giftLevel.forEach((item) => {
        if (item.id == cellValue) {
          value = item.name;
        }
      });
      return value;
    },
    formatterTableactivityStrategy(row, column, cellValue, index) {
      let value = "";
      this.activityStrategyType.forEach((item) => {
        if (item.dictKey == cellValue) {
          value = item.dictValue;
        }
      });

      return value ? value : "--";
    },
  },
};
</script>

<style scoped>
.button {
  width: 50px;
  padding: 11px 10px;
  margin-left: 49px;
  display: block;
  float: left;
}

.text {
  width: 145px !important;
  margin-left: 12px;
  float: left;
}

.mem-name p {
  margin-bottom: 20px;
  vertical-align: middle;
  line-height: 40px;
  color: rgba(170, 170, 170, 1);
}

.mem-name p:first-child {
  display: inline-block;
  width: 90px;
  text-align: right;
  vertical-align: middle;
  font-size: 14px;
  color: #606266;
  line-height: 40px;
}

.chenk {
  width: 60px;
  position: relative;
  top: -61px;
  left: 189px;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar {
  width: 100px;
  height: 100px;
  display: block;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 100px;
  height: 100px;
  line-height: 100px;
  text-align: center;
}

.iconUrl {
  width: 50px;
  height: 50px;
  margin: 5px 5px 0px 5px;
  overflow: hidden;
}

.alliconUrl {
  /* width: 50px;
        height: 50px; */
  display: flex;
  overflow: hidden;
  justify-content: center;
  align-items: center;
}

/deep/ .el-upload--picture-card {
  /* background-color: #fbfdff; */
  border: 0px dashed #c0ccda;
  border-radius: 6px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  width: 35px !important;
  height: 35px !important;
  line-height: 35px !important;
  vertical-align: top;
}

/deep/ .el-upload--picture-card i {
  font-size: 40px;
  color: #8c939d;
}

.newimg {
  display: flex;
  flex-wrap: wrap;
}

.newimg div:nth-child(2) {
  margin: 0px 10px 10px 10px;
}

.newimg div:nth-child(5) {
  margin: 0px 10px 10px 10px;
}

.newimg div:nth-child(8) {
  margin: 0px 10px 10px 10px;
}

.newimg div:nth-child(11) {
  margin: 0px 10px 10px 10px;
}

.newavatar {
  width: 100px;
  height: 100px;
  display: block;
  border: 1px dashed #c0ccda;
  border-radius: 6px;
  cursor: pointer;
}

.newavatar:hover {
  width: 100px;
  height: 100px;
  border: 1px dashed red;
  border-radius: 6px;
}
</style>



// WEBPACK FOOTER //
// src/view/page/ShopManagement/ShopManage.vue